import { useOrganizationContext } from '../contexts/OrganizationContext';
import type { UserContext, SystemRole } from '../types/organization.types';

interface UseUserContextResult {
  userContext: UserContext | null;
  isLoading: boolean;
  error: string | null;
  isAuthenticated: boolean;
  isSystemAdmin: boolean;
  isOrgUser: boolean;
  systemRole: SystemRole;
  profileId: string | null;
  refresh: () => Promise<void>;
}

/**
 * Hook to get the current user's context including profile and organization memberships.
 * 
 * Usage:
 * const { userContext, isLoading, isSystemAdmin } = useUserContext();
 */
export function useUserContext(): UseUserContextResult {
  const { 
    userContext, 
    isLoading, 
    error, 
    isSystemAdmin,
    isOrgUser,
    refreshUserContext 
  } = useOrganizationContext();

  return {
    userContext,
    isLoading,
    error,
    isAuthenticated: !!userContext,
    isSystemAdmin,
    isOrgUser,
    systemRole: userContext?.systemRole || 'creator',
    profileId: userContext?.profileId || null,
    refresh: refreshUserContext,
  };
}









